import React from "react";
import {Breadcrumb, Button, Input, Layout, Menu, Result, Spin} from "antd";
import {
    DesktopOutlined,
    PieChartOutlined,
    FileOutlined,
    TeamOutlined,
    UserOutlined,
    ScheduleOutlined,
    CarryOutOutlined,
    DashboardOutlined,
    RightOutlined,
    CalendarOutlined,
    BarsOutlined,
    BulbOutlined, ForkOutlined, ReloadOutlined,
} from '@ant-design/icons';
import Sider from "antd/es/layout/Sider";
import {Content, Footer, Header} from "antd/es/layout/layout";
import './Main.less';
import ScreenSwitcher from "./views/ScreenSwitcher";
import Dashboard from "./pages/Dashboard";
import Tasks from "./pages/Tasks";
import Stats from "./pages/Stats";
import Profile from "./pages/Profile";
import Schedule from "./pages/Schedule";
import SData from "../helpers/SData";
import Subordinates from "./pages/Subordinates";

export default class Main extends React.Component {

    static intervalUpdater = null;

    constructor(props, context) {
        super(props, context);

        this.state = {
            screen: 'dashboard',
            leftRouterState: false,

            showLoading: true,
            errorText: '',
        };
    }

    componentDidMount() {
        this.loadData();
    }

    enableUpdater = () => {
        if (Main.intervalUpdater == null) {
            console.log('Updater enabled');
            Main.intervalUpdater = setInterval(this.loadData, 10000);
        }
    }

    componentWillUnmount() {
        if (Main.intervalUpdater != null) {
            console.log('Updater disabled');
            clearInterval(Main.intervalUpdater);
            Main.intervalUpdater = null;
        }
    }

    onMenuSelect = (v) => {
        this.openMenuPage(v.key);
    }

    openMenuPage = (page) => {
        this.setState({screen: page});
    }

    render() {
        if (this.state.showLoading) {
            return (<div className='Main'>
                <div className='MainLoadingPlaceholder'>
                    <div className={'loadingScreen ' + (this.state.errorText === '' ? 'show' : 'hide')}>
                        <Spin className='loadingSpin' size="large" tip="Ожидайте..."/>
                    </div>

                    <div className={'errorScreen ' + (this.state.errorText === '' ? 'hide' : 'show')}>
                        <Result
                            className='errorBlock'
                            status="error"
                            title="Ошибка"
                            subTitle={this.state.errorText}
                            extra={[
                                <Button icon={<ReloadOutlined/>} type="primary" key="console" onClick={this.loadData}>
                                    Повторить попытку
                                </Button>,
                            ]}
                        />
                    </div>
                </div>
            </div>);
        }
        return (
            <div className='Main'>
                <div className={'LeftRouter' + (this.state.leftRouterState ? ' opened' : ' closed')}>
                    <div className='LeftRouterMain'>
                        <div className={"logo" + (!this.state.leftRouterState ? ' small' : ' big')}>
                            <div className='top'>WG</div>
                            <div className='bottom'>Staff</div>
                        </div>
                        <div className='separator'/>
                        <Menu inlineCollapsed={!this.state.leftRouterState} theme={this.props.theme}
                              onSelect={this.onMenuSelect}
                              selectedKeys={[this.state.screen]} mode="inline">
                            <Menu.Item key="dashboard" icon={<DashboardOutlined/>}>
                                Панель
                            </Menu.Item>
                            <Menu.Item key="tasks" icon={<BarsOutlined/>}>
                                Задачи
                            </Menu.Item>
                            <Menu.Item key="schedule" icon={<CalendarOutlined/>}>
                                График
                            </Menu.Item>
                            <Menu.Item key="subordinates" icon={<ForkOutlined/>}>
                                Подчиненные
                            </Menu.Item>
                            <Menu.Item key="stats" icon={<PieChartOutlined/>}>
                                Статистика
                            </Menu.Item>
                            <Menu.Item key="profile" icon={<UserOutlined/>}>
                                Профиль
                            </Menu.Item>
                        </Menu>
                    </div>
                    <div className='LeftRouterController'>
                        <div className='switchTheme'
                             onClick={this.state.leftRouterState ?
                                 () => this.props.setTheme(this.props.theme === 'light' ? 'dark' : 'light') :
                                 () => this.setState({leftRouterState: !this.state.leftRouterState})
                             }>
                            <BulbOutlined className='icon'/>
                        </div>
                        <div className='hidePanel'
                             onClick={() => this.setState({leftRouterState: !this.state.leftRouterState})}>
                            <RightOutlined className='icon'/>
                        </div>
                    </div>
                </div>
                <div className='MainContent'>
                    <ScreenSwitcher screen={this.state.screen} mainScreen='dashboard'>
                        <Dashboard key='dashboard' openMenu={this.openMenuPage}/>
                        <Tasks key='tasks'/>
                        <Schedule key='schedule'/>
                        <Subordinates key='subordinates'/>
                        <Stats key='stats'/>
                        <Profile key='profile' go={this.props.go}/>
                    </ScreenSwitcher>
                </div>
            </div>
        );
    }

    loadData = () => {
        if (this.state.errorText !== '') {
            this.setState({errorText: ''});
        }
        SData.updateBase((status, data, isNewData) => {
            if (status) {
                if (isNewData) {
                    if (Main.intervalUpdater == null) {
                        this.enableUpdater();
                    }
                    this.showLoading(false);
                } else {
                    if (this.state.showLoading) {
                        this.showLoading(false);
                    }
                }
            } else {
                setTimeout(() => {
                    this.setState({showLoading: true, errorText: data.message});
                }, 1000);
            }
        });
    }

    showLoading = (show = true) => {
        this.setState({showLoading: show});
    }
}